import { Avatar } from "@mantine/core";

import { IconFileText, IconImage } from "@/components/icons";

export function getAvatar(mimeType: string, path?: string) {
  if (mimeType.startsWith("image/") && path !== undefined) {
    return (
      <Avatar color="primary" variant="light" radius="sm" size="lg" src={path}>
        <IconImage size={32} />
      </Avatar>
    );
  }

  return (
    <Avatar color="primary" variant="light" radius="sm" size="lg">
      <IconFileText size={32} />
    </Avatar>
  );
}
